module.exports = __webpack_public_path__ + "media/images/icon-login-naver@3x-454af52d72d019f7284e160d07f50a95.png";